import React, { useState } from "react";
import { Container, Grid, Feed, Dropdown, Confirm } from "semantic-ui-react";
import Identicon from "react-identicons";
import { PlusButton } from "../../../atoms";
import SessionContext from "../../../../context/userSessionContext";
import {
  getUserRoleFromUserOdes,
  getOdeRelationFromUserOdes
} from "../helpers/getUserRoleFromUserOdes";
import DotsVerticalIcon from "mdi-react/DotsVerticalIcon";
import { EditOdeMemberModal } from "../../../organisms";
import {
  DISCONNECT_NETWORK_MEMBER_FROM_ODE
} from "../../../../graphql/mutations/users";

export default props => {
  const { team, openUserModal, odeId, refetch } = props;
  const [editModalIsOpen, setEditModalIsOpen] = useState(false);
  const [confirmModalIsOpen, setConfirmModalIsOpen] = useState(false);
  const [selectedMember, setSelectedMember] = useState({
    odeId: "",
    fullName: "",
    id: "",
    role: "",
    odeIntersectionId: ""
  });

  const disconnectUserFromNetwork = async () => {
    const { id, odeId, odeIntersectionId } = selectedMember;
    await DISCONNECT_NETWORK_MEMBER_FROM_ODE({
      networkId: id,
      odeId,
      odeRelationId: odeIntersectionId
    });
    refetch();
    setConfirmModalIsOpen(false);
  };

  const onOpenConfirmModal = () => {
    setConfirmModalIsOpen(true);
  };

  const onInputChange = event => {
    selectedMember[event.target.name] = event.target.value;
    setSelectedMember(selectedMember);
  };

  const onCloseModal = () => {
    setEditModalIsOpen(false);
  };

  const onClickEdit = (member, networkInOdeId) => {
    setSelectedMember(prevState => ({
      ...prevState,
      odeId,
      id: member.id,
      fullName: member.fullName,
      odes: member.odes,
      role: getUserRoleFromUserOdes(
        member.odes,
        odeId),
      odeIntersectionId: networkInOdeId
    }));
    setEditModalIsOpen(true);
  };

  const onClickDelete = (member, networkInOdeId) => {
    setSelectedMember(prevState => ({
      ...prevState,
      odeId,
      id: member.id,
      odeIntersectionId: networkInOdeId
    }));
    onOpenConfirmModal();
  };

  return (
    <Container
      style={{
        width: "100%",
        background: "white",
        padding: "10px"
      }}>
      <Grid style={{ borderBottom: "1px solid #dddddd" }}>
        <Grid.Row>
          <Grid.Column
            width={8}
            floated="left"
            style={{ fontSize: "10px" }}>
            Miembros de la red
          </Grid.Column>
          <Grid.Column width={3} floated="right">
            <SessionContext.Consumer>
              {({ role }) =>
                role === "SUPER_ADMIN" || role === "COORDINATOR" || role === "ADVISER" ? (
                  <PlusButton open={openUserModal} />
                ) : null
              }
            </SessionContext.Consumer>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <Feed>
              {team.map((member, index) => {
                const odeRelation =
                  getOdeRelationFromUserOdes(member.odes, odeId) || {};
                const networkInOdeId = odeRelation.id || "";

                return (
                  <Feed.Event key={index}>
                    <Feed.Label>
                      <Identicon size={35} string={member.fullName} />
                    </Feed.Label>
                    <Feed.Content
                      style={{ fontSize: "11px" }}>
                      {member.fullName}
                      <Feed.Meta style={{display: "block"}}>
                        {getUserRoleFromUserOdes(member.odes, odeId)}
                      </Feed.Meta>
                    </Feed.Content>
                    <div>
                      <React.Fragment>
                        <Dropdown
                          icon={<DotsVerticalIcon color="#5F39DE" />}
                          pointing="right">
                          <Dropdown.Menu>
                            <Dropdown.Item
                              icon="edit"
                              text="Editar"
                              onClick={() => {
                                onClickEdit(member, networkInOdeId);
                              }} />
                            <Dropdown.Item
                              icon="delete"
                              text="Eliminar"
                              onClick={() => {
                                onClickDelete(member, networkInOdeId);
                              }} />
                          </Dropdown.Menu>
                        </Dropdown>
                      </React.Fragment>
                    </div>
                  </Feed.Event>
                );
              })}
            </Feed>
          </Grid.Column>
        </Grid.Row>
      </Grid>
      {
        <EditOdeMemberModal
          relation="NETWORK"
          refetch={refetch}
          data={selectedMember}
          isOpen={editModalIsOpen}
          onClose={onCloseModal}
          onInputChange={onInputChange} />
      }
      {
        <Confirm
          open={confirmModalIsOpen}
          onCancel={ () => {
            setConfirmModalIsOpen(false);
            }}
          onConfirm={disconnectUserFromNetwork}
          header="Eliminar miembro"
          content={"Esta acción no es reversible."} />
      }
    </Container>
  );
};
